module.exports = __webpack_public_path__ + "img/txt.24910e21.svg";